import CloseIcon from "@mui/icons-material/Close";
import { Button, Stack } from "@mui/material";
import { Severity } from "constants/Severity";
import { NotificationResourceAction } from "models/Resources/NotificationResource";
import { SnackbarKey, useSnackbar } from "notistack";
import { JSX, useEffect } from "react";

type Props = {
  isOpen: boolean;
  message: string;
  autoHideDuration: number;
  severity: Severity;
  onClose: () => void;
  actions?: NotificationResourceAction[];
};

const AlertSnackbar = ({
  isOpen,
  message,
  autoHideDuration,
  severity,
  onClose,
  actions,
}: Props) => {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const createActionsButtons = function (snackbarId: SnackbarKey) {
    const actionsButtons: JSX.Element[] = [];
    actions?.map((action) => {
      actionsButtons.push(
        <Button
          size="small"
          variant="contained"
          onClick={() => {
            action.action();
            closeSnackbar(snackbarId);
          }}
        >{action.text}</Button>
      );
    });

    return actionsButtons;
  };

  const close = (snackbarId: SnackbarKey) => (
    <>
      <Stack
        style={{
          width: "max-content",
          flexDirection: "row",
        }}
      >
        {createActionsButtons(snackbarId)}
        <Button
          onClick={() => {
            closeSnackbar(snackbarId);
            onClose;
          }}
        >
          <CloseIcon style={{ color: "white" }} />
        </Button>
      </Stack>
    </>
  );

  useEffect(() => {
    if (message != "" && isOpen) {
      enqueueSnackbar(message, {
        action: (snackbarId) => close(snackbarId),
        autoHideDuration: autoHideDuration,
        variant: severity,
        preventDuplicate: false,
        onClose: () => {
          onClose();
        },
      });
    }
  }, [enqueueSnackbar, isOpen, message]);
  return null;
};

export default AlertSnackbar;
